/**
 * Spread onto an `Input` / `InputMasked` whose value is not something a
 * password manager or autofill extension should touch — operational
 * identifiers (key names, clinic ids, exchange ids, API keys), dates, member
 * ids. Keeps their icons and suggestions out of the field. One constant so a
 * newly discovered vendor flag is added in exactly one place.
 */
export const AUTOFILL_OFF = {
  autoComplete: 'off',
  inputFieldProps: {
    'data-1p-ignore': true, // 1Password
    'data-lpignore': 'true', // LastPass
    'data-bwignore': true, // Bitwarden
    'data-form-type': 'other', // Dashlane's documented field-type signal
    'data-dashlane-ignore': 'true',
  },
} as const;
